<template>
    <div class="mobile-news" id="mobile-news">
            <transition name="fade">
                <div class="nav">
                    <ul>
                        <li><a href="/explore/xfz2017/" target="_blank">首页</a></li>
                        <li><a href="/explore/xfz2017/#s-guest" target="_blank">参会嘉宾</a></li>
                        <li><a href="/explore/xfz2017/#s-agenda" target="_blank">会议议程</a></li>
                        <li><a href="/explore/xfz2017/#s-tickets" target="_blank">参会购票</a></li>
                        <li><a href="/explore/xfz2017/#s-partners" target="_blank">合作机构</a></li>
                        <li><a href="/explore/xfz2017/#s-location" target="_blank">场地信息</a></li>
                        <li><a href="/explore/xfz2017/#s-contact-us" target="_blank">联系我们</a></li>
                    </ul>
                </div>
            </transition>
        <div class="banner" id="section-banner">
        </div>
        <br>
        <!-- 大会回顾视频 -->
        <div class="mobile-news-wrap">
            <div class="section live">
                <div class="live-wrap">
                    <div class="live-title"><img class="img-title" src="../assets/images/video-mo.png" alt=""></div>
                </div>
            </div>
        </div>
        <div class="section course">
            <div class="course-wrap">
                <div class="course-title">未来创新专场</div>
                <div class="course-items-wrap">
                <div class="course-area">
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/178.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513063811_824.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">吉姆·罗杰斯/量子基金创办人</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/179.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513065034_406.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">李黎/嘉程资本创始合伙人、小饭桌创始人； 张颖/经纬中国创始管理合伙人</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/180.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513065071_142.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">张巳丁/ofo小黄车联合创始人</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/181.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513066076_626.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">郭晨凯/韬映资本董事总经理；吉姆·罗杰斯/量子基金基金创办人 </div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/182.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513066148_85.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资" class="main"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">脱不花/得到App联合创始人兼CEO </div>
                            </div>
                        </a>
                    </div>
                </div>
                </div>
            </div>
            <div class="course-wrap">
                <div class="course-title">未来智慧专场</div>
                <div class="course-items-wrap">
                <div class="course-area">
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/183.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513066172_946.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">于伟/微软全球合伙人、微软亚太研发集团工程院副院长</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/184.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513066370_185.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">Yosi Lahad/Co-Founder of NextWave Robotics</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/185.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513066402_508.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">谢冠超/云知声IOT事业部总裁</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/186.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513648493_271.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">汪玉/深鉴科技联合创始人</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/187.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513067515_281.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">钱诚/寒武纪副总裁</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/188.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513068771_16.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">黄畅/地平线联合创始人兼算法副总裁</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/189.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513073996_456.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">主持：张一甲 ,科技智库甲子光年创始人兼CEO</div>
                            </div>
                        </a>
                    </div>
                </div>
                </div>
            </div>
            <div class="course-wrap">
                <div class="course-title">未来消费专场</div>
                <div class="course-items-wrap">
                <div class="course-area">
                    <!-- <div class="course-item">
                        <a href="http://www.xfz.cn/course/190.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074025_156.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">徐惠/蚂蚁金服芝麻信用首席产品架构师</div>
                            </div>
                        </a>
                    </div> -->
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/191.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074060_532.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">陈安妮/快看漫画创始人兼CEO</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/192.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074088_956.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">司江华/猩便利联合创始人兼总裁</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/193.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074115_897.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">张剑/纳什空间创始人兼CEO</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/194.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074138_654.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">刘锐/天使之橙、Vingoo维果部落联合创始人</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/195.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074316_971.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">主持人：曲凯，42章经创始人</div>
                            </div>
                        </a>
                    </div>
                </div>
                </div>
            </div>
            <div class="course-wrap">
                <div class="course-title">未来科技金融专场</div>
                <div class="course-items-wrap">
                <div class="course-area">
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/197.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074335_754.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">吴逖/众安保险副总经理兼CMO</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/198.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513648695_27.jpg-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">汤鹏/量子保创始人</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/199.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074402_194.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">陈龙/大象保险CTO</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/200.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074430_204.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">巫天华/老虎证券创始人兼CEO</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/201.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074473_908.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">主持人：陈一佳 , 路透财经评论员</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/203.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513075126_301.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">Madhu, CEO of KrazyBee</div>
                            </div>
                        </a>
                    </div>
                    <div class="course-item">
                        <a href="http://www.xfz.cn/course/202.html" target="_blank">
                            <div class="info-logo"><img src="http://static-image.xfz.cn/1513074496_627.png-course.list.small" alt="资本寒冬，创业公司如何快速获取融资"> <span class="tags"></span></div>
                            <div class="info-content">
                            <div class="info-author">主持人：谢荫智, CBIPA中巴互联网促进会CEO</div>
                            </div>
                        </a>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- 大会新闻头部文案 -->
        <div class="mobile-news-wrap">
            <div class="section live">

                <div class="live-wrap">
                    <div class="live-title">
                        <img class="img-title" src="../assets/images/m-news.png" alt="">
                        <div class="refresh" @click="refreshContent()"> 刷新 </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-news-list">
            <div class="title-area"  v-if="false">
                <div class="title">大会相关新闻</div>
                <div class="refresh" @click="refreshContent()">
                    <div class="refresh-img">
                        <img src="../assets/icon-refresh.png">
                    </div>
                    <div class="refresh-content">刷新</div>
                </div>
            </div>
            <template  v-for="item in newsData">
                <mobile-news-item  :news="item"></mobile-news-item>
            </template>
            <template v-if="newsData.length == 0">
                <div style="width:200px; text-align:center; margin: 20px auto; font-size:18px;">暂无新闻</div>
                <br>
            </template>
        </div>
        <br><br><br><br>
    </div>
</template>

<style lang="scss">

@media screen and (min-width: 280px) {html{font-size:74.6px;}}
@media screen and (min-width: 320px) {html{font-size:85.33px;}}
@media screen and (min-width: 360px) {html{font-size:96px;}}
@media screen and (min-width: 375px) {html{font-size:100px;}}
@media screen and (min-width: 414px) {html{font-size:110.4px;}}
@media screen and (min-width: 440px) {html{font-size:117.33px;}}
@media screen and (min-width: 480px) {html{font-size:128px;}}
@media screen and (min-width: 520px) {html{font-size:138.66px;}}
@media screen and (min-width: 540px) {html{font-size:144px;}}
@media screen and (min-width: 600px) {html{font-size:160px;}}
@media screen and (min-width: 768px) {html{font-size:208.4px;}}
#mobile-news{
    font-size: .12rem;
    background-color: black;
    .nav{
       background-color: rgba(0,0,0,0.3);
       // position: fixed;
       // z-index: 199;
       ul{
           white-space: nowrap;
           overflow: auto;
           display: block;
           padding-left: 10px;
           li{
               display: inline;
               font-size: .15rem;
               height: .4rem;
               line-height: .4rem;
               margin-right: 10px;
               list-style: none;
               a{
                   text-decoration: none;
                   color: #fff;
               }
           }
       }
       ul::-webkit-scrollbar{
           display: none;
       }
    }
    .banner{
        height: 140px;
        background:{
            image: url('../assets/images/m-banner.png');
            repeat: no-repeat;
            size:100%;
        }
        .logo{
            padding-top:.16rem;
            margin-bottom: .1rem;
            img{
                display: block;
                margin: 0 auto;
                text-align: center;
                width: 1.4rem;
            }
        }
        .conf-name{
            width: 100%;
            text-align: center;
            color: #fff;
            .name-main{
                font-size: .24rem;
                font-weight: bold;
                margin-top: .2rem;
            }
            .name-sub{
                font-size: .18rem;
                margin-bottom: .2rem;
            }
            .hotel{
                font-size: .12rem;
            }
        }
    }
    .news-title{
        font-size: .24rem;
        text-align: left;
        padding-left: 20px;
        color: #042745;
    }
    .mobile-news-wrap {
        // background-color: #fff;
        margin: 0 auto;
        padding-left: 10px;
        // width: 90%;
        .live-wrap {
            .live-title {
                .img-title {
                    margin-top: .2rem;
                    margin-bottom: .1rem;
                    height: .23rem;
                }
                .refresh {
                    float: right;
                    color: #fff;
                    font-size: .2rem;
                    padding-top: .18rem;
                }
            }
            .middle-divider {
                height: 2px;
                background-repeat: no-repeat;
                background-image: url('../assets/images/divider-line.png');
                margin: .1rem 0;
            }
            .live-sub-title {
                color: #fff;
                font-size: .18rem;
                font-weight: bold;
                span {
                    display: inline-block;
                    margin-bottom: .1rem;
                }
                .title {
                    background-image: url('../assets/images/half-red-bg.png');
                    height: .3rem;
                    line-height: .3rem;
                }
                .time {
                    font-size: .12rem;
                    margin-right: .05rem;
                }
            }
            .live-items-wrap {
                img {
                    width: 1rem;
                    margin-right: .1rem;
                    margin-bottom: .05rem;
                }
            }
            .tuwen-live {
                margin-left: .02rem;
                margin-bottom: .1rem;
                img {
                    width: 1rem;
                    margin-right: .1rem;
                    margin-bottom: .05rem;
                }
                span {
                    display: inline-block;
                    // border: 1px solid #fff;
                    font-size: .2rem;
                    color: #fff;
                    font-weight: bold;
                    vertical-align: top;
                    margin-right: .28rem;
                }
            }
        }
    }
    .mobile-news-list{
        background-color: #fff;
        margin: 10px 10px 0px 10px;
        padding-top: 10px;
        .title-area{
            width: 90%;
            margin: 0 auto;
            color: #042745;
            .title{
                display: inline-block;
                font-size: .24rem;
            }
            .refresh{
                display: inline-block;
                float: right;
                font-size: .2rem;
                height: .4rem;
                line-height: .4rem;
                .refresh-img{
                    display: inline-block;
                    img{
                        padding-top: 5px;
                        display: block;
                        height: 22px;
                    }
                }
                .refresh-content{
                    color: #042745;
                    display: inline-block;
                }
            }
        }
    }

    .live{
        margin-bottom: 10px;
        .live-area{
            margin: 10px;
            padding: 10px 0;
            background-color: #fff;
        }
        .date-title{
            font-size: 24px;
            color:#0047ca;
            margin-top:10px;
            text-align:left;
            width: 90%;
            margin: 0 auto;
        }
        .live-item{
            // display: inline-block;
            width: 90%;
            margin: .08rem auto;
            border: 2px solid #1a74bf;
            .live-name{
                font-size: .14rem;
                color: #0047ca;
                padding:6px;
                background-color: #1a74bf;
                a{
                    font-weight: bold;
                    text-decoration: none;
                    color: #fff;
                }
            }
            .live-links{
                background-color: #fff;
                a{
                    color: #1a74bf;
                    text-decoration: none;
                }
                .link-item{
                    font-size: .14rem;
                    font-weight: bold;
                    display: inline-block;
                    padding: 4px 40px;
                }
                .link-divider{
                    display: inline-block;
                    font-size: .14rem;
                    width: 1px;
                    color: #1a74bf;
                    background-color: #1a74bf;
                }
            }
        }
    }
    // 大会回顾视频
    .course{
        padding:10px;
        background:#f2f2f2;
        .course-wrap{
            width: 100%;
            margin: 0 auto;
            .course-items-wrap{
                text-align:center;
            }
            &:nth-child(2){
            }
        }
        .course-title{
            font-size: .24rem;
            color: #042745;
            width: 100%;
            margin-bottom:10px;
        }
        .course-area{
            display:block;
            overflow:hidden;
        }
        .date-title{
            width: 100%;
            margin: 0 auto;
            text-align: left;
            font-size: 24px;
            color:#0047ca;
            margin-top:10px;
        }
        &:nth-child(2){
            .course-item {
                margin-bottom:20px;
            }
        }
        .course-item{
            float:left;
            width: 100%;
            margin-bottom:10px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, .1);
            a {
                text-decoration:none;
            }
            .info-price {
                font-size: 20px;
                color: #f54a4a;
                span {
                    font-size: 14px;
                    margin-right: 5px;
                }
                &.free {
                    color: #7ed321;
                }
            }
            .info-start {
                &.course {
                    color: #00caa9;
                }
                &.replay {
                    color: #f5a623;
                }
            }
            .info-logo {
                font-size:0;
                position: relative;
                .tags {
                    display:inline-block;
                    width:50px;
                    height:50px;
                    position: absolute;
                    top:50%;
                    left:50%;
                    margin-top:-25px;
                    margin-left:-25px;
                    background:url("http://static-image.xfz.cn/player-latest-icon.png");
                }
                img {
                    width: 100%;
                }
            }
            .info-content {
                box-sizing: border-box;
                border-radius: 0 0 6px 6px;
                padding: 0 15px;
                background: #fff;
                .course-item-title {
                    font-size: 16px;
                    text-align:left;
                    color:rgb(105,105,105);
                    line-height: 26px;
                    height: 62px;
                    overflow: hidden;
                }
                .info-author {
                    text-align:left;
                    line-height: 34px;
                    font-size: 14px;
                    color: #9b9b9b;
                    height: 34px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .info-start {
                    position: absolute;
                    bottom: 15px;
                    font-size: 13px;
                    &.not-start {
                        color: #9b9b9b;
                    }
                }
                .info-series-num,
                .info-time {
                    position: absolute;
                    bottom: 37px;
                    font-size: 14px;
                }
                .info-haspay,
                .info-series-price,
                .info-price {
                    text-align: right;
                    right:10px;
                    position: absolute;
                    line-height: 30px;
                    bottom: 10px;
                }
            }
        }
    }
}
</style>


<script>
import MobileNewsItem from './MobileNewsItem.vue'
import util from '../assets/js/util'
import liveData from '../assets/js/livedata.js'

export default{
    components:{ MobileNewsItem },
    data(){
        return {
            newsData: [],
            liveData: [],
            // todo delete
            newDataFake:{
                "code": 200,
                "data": [
                    {
                        "tread": 0,
                        "like": 0,
                        "title": "第第第第第第第第第第第四四文章四四文章四四文章四四文章四四文章四四文章四四文章四四文章四四文章四四文章",
                        "photo": "http://static-image.xfz.cn/1489643700_594.png",
                        "author": {
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "name": "刘星 王自力 小妹"
                        },
                        "is_original": false,
                        "article_type": " 海外投资报告",
                        "intro": "22",
                        "source": "小饭桌1",
                        "time": "2017-03-16 13:55:00",
                        "keywords": [
                            "马克思",
                            "金融",
                            "大米"
                        ],
                        "author_member": {
                            "uid": "",
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "company": "小饭桌",
                            "work": "fa",
                            "article_count": 4,
                            "signature": "介绍",
                            "author_id": 23,
                            "email": "xing@xfz.cn",
                            "realname": "刘星"
                        },
                        "uid": 71
                    },
                    {
                        "tread": 0,
                        "like": 0,
                        "title": "第第第第第第第第第第第四四文章四四文章四四文章四四文章四四文章四四文章四四文章四四文章四四文章四",
                        "photo": "http://static-image.xfz.cn/1489643369_417.png",
                        "author": {
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "name": "刘星"
                        },
                        "is_original": false,
                        "article_type": "原创",
                        "intro": "哈哈",
                        "source": "xioafanz",
                        "time": "2017-03-16 13:49:29",
                        "keywords": [],
                        "author_member": {
                            "uid": "",
                            "photo": "http://7xl0ey.com2.z0.glb.qiniucdn.com/1450352114_45817.jpg",
                            "company": "小饭桌",
                            "work": "fa",
                            "article_count": 4,
                            "signature": "介绍",
                            "author_id": 23,
                            "email": "xing@xfz.cn",
                            "realname": "刘星"
                        },
                        "uid": 70
                    }
                ]
            }
        }
    },
    methods:{
        getNewsListFake(){
            this.newsData = this.newDataFake.data
        },
        getNewsList() {
            var self = this
            util.resource({
                url: '/api/website/articles/?tag=2017小饭桌全球青年创业者大会&n=1000&p=1',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.newsData = res.data
                    }
                }
            })
        },
        refreshContent(){
            this.newsData = []
            this.getNewsList()
        }
    },
    mounted(){
        // this.getNewsListFake()
        this.getNewsList()
        this.liveData = liveData
        util.getWx()
    }
}
</script>



// WEBPACK FOOTER //
// MobileNews.vue?cfdef9da